export const questionListTC = [
    {
        id: 0,
        question: "如何登入「電子表格遞交系統」？",
        answer: [
            {
                number: 1,
                description: "「統一登入系統」(CLO) 登入方式：「統一登入系統」(CLO) 使用者有兩種登入方式：",
                description0: "1. 透過",
                description6: "2. 直接透過「電子表格遞交系統」(e-FormSS) ",
                description7: "登入",
                CLOEfomssHyperlink: "cloportallogin",
                SSLOEfomssHyperlink: "loginSSLO",
                PublicEfomssHyperlink: "loginPublic",
                link: "連結",
                clo: "「統一登入系統」",
                dot: "。",
                CLOHyperlink: "https://clo.edb.gov.hk",   
                description3: "SSLO登入方式：SSLO使用者可以直接使用「電子表格遞交系統」(e-FormSS) ",
                description4: "公眾登入方式：公眾可直接使用「電子表格遞交系統」(e-FormSS) ",
                description5:" 他們可以選擇使用自己的電子郵件地址或「智方便」進行身份驗證。",
                multiple : "3"
            }
        ]
    },


    {
        id: 1,
        question: "我應該使用哪種登入方法：統一登入系統(CLO)、SSLO，還是公眾帳號？",
        answer: [
            {
                number: 1,
                description: "「統一登入系統」(CLO) 登入方式：適用於教師、校長和校監等。他們必須擁有「電子化服務入門網站」(e-Services) ，「統一登入系統」(CLO) 或「培訓行事曆系統」(TCS) 帳戶才能登入。",
                description3: "SSLO 登入方式：擁有 SSLO 帳戶的非政府組織。",
                description4: "公眾登入方式: 供所有公眾使用。",
                multiple : "3"
            }
        ]
    },

    {
        id: 2,
        question: "提交電子表格接受的附件的文件大小或文件類型有限制嗎？",
        answer: [
            {
                number: 1,
                description: "有的，每張表格的要求可能會有所不同。請查看具體表格對應的說明。"
            }
        ]
    },

    {
        id: 3,
        question: "表格支援那些簽署方式？",
        answer: [
            {
                number: 1,
                title: "目前支援三種簽署方式：\n",
                description: "電子簽署。",

                description3: "上傳簽署圖像檔案。（可接受的檔案類型：jpg、jpeg、png；附件上限為 3MB，檔案名稱長度不得超過 70 個字元。）",

                description4: "「智方便+」。（部份表格只接受此方式。）",
                multiple : "3"
            },
        ]
    },

    {
        id: 4,
        question: "為什麼我看不到想要填寫的表格？",
        answer: [
            {
                number: 1,
                description: "某些表格可能只開放予特定群組（公眾登入/「統一登入系統」(CLO)/SSLO）。如果你不屬於指定群組，你可能看不到該表格。你可以聯絡具有學校管理員/機構行政戶口權限的使用者 (例如校長、學校行政主戶 (MSA) 及「統一登入系統」學校行政戶口 (CSA)等)，前往「電子表格遞交系統」的委派頁面並將表格委派給你。"
            }
        ]
    },

    {
        id: 5,
        question: "如果表格被拒絕，可以再次提交同一表格嗎？",
        answer: [
            {
                number: 1,
                description: "不可以，被拒絕的表格不能再次提交。如果表格被拒絕，你只能使用新表格重新申請。不過，如果表格僅被其他單位退回，你可以進行編輯並再次提交表格。"
            }
        ]
    },
    
    {
        id: 6,
        question: "如何委派表格？",
        answer: [
            {
                number: 1,
                description: "委派權限僅適用於管理員、校長和校監。委派功能可以在「委派頁面」下的功能表列中找到。"
            }
        ]
    },

    {
        id: 7,
        question: "為什麼我不能委派表格給我的同事？",
        answer: [
            {
                number: 1,
                description: "該表格可能僅限於特定職位，或者你的同事與你不屬於同一學校或組織。"
            }
        ]
    },

    {
        id: 8,
        question: "我如何查閱表格的申請狀態？",
        answer: [
            {
                number: 1,
                description: "登錄「電子表格遞交系統」並點選「表格查詢」。"
            }
        ]
    },

    {
        id: 9,
        question: "如何查詢表格參考編號？",
        answer: [
            {
                number: 1,
                description: "表格參考編號顯示在通知電子郵件中，也可以在「電子表格遞交系統」的「表格查詢」中找到。"
            }
        ]
    },

    {
        id: 10,
        question: "我在學校任職，但為甚麼我無法在「電子表格遞交系統」中更新個人資料？",
        answer: [
            {
                number: 1,
                description: "「電子表格遞交系統」內有關用戶的個人資料由「電子化服務入門網站」 (e-Services)、「統一登入系統」 (CLO)或「培訓行事曆系統」 (TCS) 提供。用戶需登入以上有關網站/系統以更新個人資料。"
            }
        ]
    },

    {
        id: 11,
        question: "為甚麼學校的學校行政主戶 (MSAs) 和「統一登入系統」學校行政戶口 (CSAs)在職員管理中無法新增、編輯或刪除職員資料？",
        answer: [
            {
                number: 1,
                description: "職員資料由「電子化服務入門網站」(e-Services)、「統一登入系統」(CLO) 或「培訓行事曆系統」(TCS) 提供。用戶需登入以上有關網站/系統以更新有關資料。"
            }
        ]
    },

    {
        id: 12,
        question: "公眾/機構用戶如何在「電子表格遞交系統」中更新個人資料？",
        answer: [
            {
                number: 1,
                description: "登入「電子表格遞交系統」後，在「個人資料」中更新。"
            }
        ]
    },

    {
        id: 13,
        question: "機構如何刪除現有行政戶口？",
        answer: [
            {
                number: 1,
                description: "機構必需有多於一個行政戶口時，才能刪除其他的行政戶口。"
            }
        ]
    },

    {
        id: 14,
        question: "如何一次過修改所有表格的預設申請人或審批人？",
        answer: [
            {
                number: 1,
                description: "目前系統不支援該功能。使用者需要分別為每張表格選擇申請人或審批人。"
            }
        ]
    },

    {
        id: 15,
        question: "申請人提交表格後，為什麼審批人沒有收到該表格？",
        answer: [
            {
                number: 1,
                description: "當指定人委派表格時，審批人的帳戶應與指定人選擇的帳戶相符。例如，審批人通常是校長的個人帳戶，那校長應以個人帳戶登入系統，才會收到該表格。"
            }
        ]
    },

    {
        id: 16,
        question: "如果我對填寫表格有疑問該怎麼辦？",
        answer: [
            {
                number: 1,
                description: "用戶可前往「電子表格遞交系統」主頁左側，選擇「電子表格」，然後填寫表格名稱。點擊表格名稱右側的",
                imageSrc: "1",
                description2:"圖示查看與表格相關的查詢電話號碼以獲得協助。"
            }
        ]
    },

    {
        id: 17,
        question: "為什麼委派時找不到審批人帳號？",
        answer: [
            {
                number: 1,
                description: "如果是在「電子化服務入門網站」(e-Services)，「統一登入系統」(CLO) 或「培訓行事曆系統」(TCS)建立的新帳戶，指定人可能找不到申請人或審批人的帳戶。在這種情況下，指定人需要等待1-2天才能成功委派該申請人或審批人。"
            }
        ]
    },
    {
        id: 18,
        question: "可以一次過更改所有已遞交表格的審批人嗎？",
        answer: [
            {
                number: 1,
                description: "不可以。學校行政主戶 (MSAs)、「統一登入系統」學校行政戶口 (CSAs)、校監、校長或機構負責人必須在委派頁面內逐一更改每張表格。原來的審批人亦可於表格內將表格委派給新的審批人。"
            }
        ]
    },
    {
        id: 19,
        question: "為什麼我在委派頁面找不到要委派的表格？",
        answer: [
            {
                number: 1,
                description: "如果委派頁面上不存在該表格，請聯絡「電子表格遞交系統」支援熱線尋求進一步協助。"
            }
        ]
    },
    {
        id: 20,
        question: "如果我提交了錯誤的表格該怎麼辦？",
        answer: [
            {
                number: 1,
                description: "請參閱申請/表格的資料並聯絡教育局相關的部門以獲得協助。"
            }
        ]
    },
    
];
